import { traduciErrore } from "./erroreServer";

export const errorMessage = [
	{ value: "[UsernameExistsException] An account with the email already exists.", label: "e-mail già esistente" },
    { value: "[UsernameExistsException] Already found an entry for the provided username.", label: "username già esistente" },
];

export function getErrorLabel(key) {
    const error = errorMessage.find(err => err.value === key);
    return error ? error.label : traduciErrore(key);
}